
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HSVGIcon',

  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
});
